/* eslint-disable */
export default {
    name: 'InternalTransfer',

    props: {
        operation: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true
        }
    },
    /**
     * @override
     */
    data() {
        return {
            data: {}
        };
    },
    /**
     * @override
     */
    beforeMount() {
        this.fetchData();
    },
    methods: {
        /**
         * Asignamos los valores en sus campos
         */
        fetchData() {
            if (this.operation.key_operation_type === 'SOLICITUD_TRASPASO_EXTERNO_ENTRADA') {
                if (!['INNOCAPITAL_GLOBAL', 'INNOCAPITAL_MIXTO_GLOBAL'].includes(this.operation.key_product)) {
                    this.externalEntryTransfer();
                }
            } else if (this.operation.key_operation_type === 'SOLICITUD_TRASPASO_EXTERNO_SALIDA') {
                if (!['INNOCAPITAL_GLOBAL', 'INNOCAPITAL_MIXTO_GLOBAL'].includes(this.operation.key_product)) {
                    this.externalExitTransfer();
                }
            } else if (this.operation.key_operation_type === 'SOLICITUD_TRASPASO_INTERNO') {
                if (!['INNOCAPITAL_GLOBAL', 'INNOCAPITAL_MIXTO_GLOBAL'].includes(this.operation.key_product)) {
                    this.internalTransfer();
                }
            }
        },

        /**
         * Datos de SOLICITUD_TRASPASO_EXTERNO_ENTRADA
         */
        externalEntryTransfer() {
            if (this.type === 'salida') {
                // Datos fondo salida (izquierda)
                this.data.fund_name = this.operation.xt_fund_name;
                this.data.isin_code = this.operation.xt_isin_code;
                this.data.fund_official_reg_number = this.operation.xt_fund_official_reg_number;
                this.data.fund_nif = this.operation.xt_fund_nif;
                this.data.gestor = this.operation.xt_gestor;
                this.data.provider = this.operation.xt_provider;
                this.data.gestor_official_reg_number = this.operation.xt_gestor_official_reg_number;
                this.data.provider_official_reg_number = this.operation.xt_provider_official_reg_number;
                this.data.gestor_nif = this.operation.xt_gestor_nif;
                this.data.provider_nif = this.operation.xt_provider_nif;
                this.data.account_origin = this.operation.xt_acount_origin;
                this.data.snce = this.operation.snce;
                this.data.contribution_account_code = this.operation.contribution_account_code
            } else {
                // Datos fondo entrada (derecha)
                this.data.fund_name = this.operation.name_product;
                this.data.isin_code = this.operation.product.isin_code;
                this.data.fund_official_reg_number = this.operation.main_product ?
                    String(this.operation.main_product.cnmv_fund_register_number) :
                    String(this.operation.product.cnmv_fund_register_number);
                this.data.fund_nif = this.operation.main_product ?
                    this.operation.main_product.nif : this.operation.product.nif;
                this.data.gestor = this.operation.gestor ? this.operation.gestor.gestor_name : '';
                this.data.gestor_official_reg_number = this.operation.gestor ? this.operation.gestor.gestor_cnmv : '';
                this.data.gestor_nif = this.operation.gestor ? this.operation.gestor.gestor_nif : '';
                this.data.account_origin = this.operation.product.iban_code;
                this.data.snce = this.operation.product.snce;
            }
        },

        /**
         * Datos de SOLICITUD_TRASPASO_EXTERNO_SALIDA
         */
        externalExitTransfer() {
            if (this.type === 'salida') {
                // Datos fondo salida (izquierda)
                this.data.fund_name = this.operation.name_product;
                this.data.isin_code = this.operation.product.isin_code;
                this.data.fund_official_reg_number = this.operation.product.cnmv_fund_register_number;
                this.data.fund_nif = this.operation.product.nif;
                this.data.gestor = this.operation.product.gestor;
                this.data.gestor_official_reg_number = this.operation.product.gestor_cnmv;
                this.data.gestor_nif = this.operation.product.gestor_cnmv;
                this.data.account_origin = this.operation.product.bank_account_iban;
                this.data.snce = this.operation.product.snce;
            } else {
                // Datos fondo entrada (derecha)
                this.data.fund_name = this.operation.xt_fund_name;
                this.data.isin_code = this.operation.xt_isin_code;
                this.data.fund_official_reg_number = this.operation.xt_fund_official_reg_number;
                this.data.fund_nif = this.operation.xt_fund_nif;
                this.data.gestor = this.operation.xt_gestor;
                this.data.provider = this.operation.xt_provider;
                this.data.gestor_official_reg_number = this.operation.xt_gestor_official_reg_number;
                this.data.provider_official_reg_number = this.operation.xt_provider_official_reg_number;
                this.data.gestor_nif = this.operation.xt_gestor_nif;
                this.data.provider_nif = this.operation.xt_provider_nif;
                this.data.account_origin = this.operation.xt_acount_origin;
                this.data.snce = this.operation.snce;
                this.data.contribution_account_code = this.data.contribution_account_code;
            }
        },

        /**
         * Datos de SOLICITUD_TRASPASO_INTERNO
         */
        internalTransfer() {
            if (this.type === 'salida') {
                // Datos fondo salida (izquierda)
                this.data.fund_name = this.operation.name_product
                this.data.isin_code = this.operation.product.isin_code
                this.data.fund_official_reg_number = this.operation.product.cnmv_fund_register_number
                this.data.fund_nif = this.operation.product.nif
                this.data.gestor = this.operation.product.gestor
                this.data.gestor_official_reg_number = this.operation.product.gestor_cnmv
                this.data.gestor_nif = this.operation.product.gestor_cnmv
                this.data.account_origin = this.operation.product.bank_account_iban
                this.data.snce = this.operation.product.snce
            } else {
                // Datos fondo entrada (derecha)
                this.data.fund_name = this.operation.target_product.name
                this.data.isin_code = this.operation.target_product.isin_code
                this.data.fund_official_reg_number = this.operation.target_product.cnmv_fund_register_number
                this.data.fund_nif = this.operation.target_product.nif
                this.data.gestor = this.operation.target_product.gestor
                this.data.gestor_official_reg_number = this.operation.target_product.gestor_cnmv
                this.data.gestor_nif = this.operation.target_product.gestor_cnmv
                this.data.account_origin = this.operation.target_product.bank_account_iban
                this.data.snce = this.operation.target_product.snce
            }
        }
    }
};
